import { render, staticRenderFns } from "./resultSubmint.vue?vue&type=template&id=2715057a&scoped=true&"
import script from "./resultSubmint.vue?vue&type=script&lang=js&"
export * from "./resultSubmint.vue?vue&type=script&lang=js&"
import style0 from "./resultSubmint.vue?vue&type=style&index=0&id=2715057a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2715057a",
  null
  
)

export default component.exports